import { addressHasChanged } from '../../util/address';
import { outletCategories } from '../../wheretobuy/outletCategories';

export const isValidOutlet = outlet => {
  const errors = getOutletValidationErrors(outlet);
  return Object.keys(errors).length < 1;
};

export const getOutletValidationErrors = outlet => {
  const errors = {};
  if (!outlet.id) {
    errors.id = 'id is required';
  }
  if (!outlet.name ||
    typeof outlet.name !== 'string' ||
    outlet.name.length < 4) {
    errors.name = 'name must be at least 4 characters long';
  }
  if (!coordsAreValid(outlet.geometry)) {
    errors.geometry = 'geometry must be a valid geojson point';
  }
  try {
    const lng = outlet.geometry.coordinates[0];
    if (typeof lng !== 'number' || lng < -180 || lng > 180) {
      errors.longitude = 'longitude must be a number between -180 and 180';
    }
  } catch (_) {
    errors.longitude = 'longitude is required';
  }
  try {
    const lat = outlet.geometry.coordinates[1];
    if (typeof lat !== 'number' || lat < -90 || lat > 90) {
      errors.latitude = 'latitude must be a number between -90 and 90';
    }
  } catch (_) {
    errors.latitude = 'latitude is required';
  }
  try {
    if (outlet.url) {
      const url = new URL(outlet.url);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') {
        errors.url = 'url must be an http or https url';
      }
    }
  } catch (_) {
    errors.url = 'url must be a valid RFC 3886 url';
  }
  if (Object.keys(outletCategories).includes(outlet.category) === false) {
    errors.category =
      `category must be one of ${Object.keys(outletCategories).join(', ')}`;
  }
  return errors;
};
const coordsAreValid = geo => {
  if (!geo) return false;
  if (typeof geo.type !== 'string') return false;
  if (geo.type !== 'Point') return false;
  if (Array.isArray(geo.coordinates) === false) return false;
  if (geo.coordinates.length !== 2) return false;
  if (typeof geo.coordinates[0] !== 'number') return false;
  if (typeof geo.coordinates[1] !== 'number') return false;
  if (geo.coordinates[0] > 90 || geo.coordinates[0] < -90) return false;
  if (geo.coordinates[1] > 180 || geo.coordinates[1] < -180) return false;
  return true;
};

const geometryHasChanged = (geo1, geo2) => {
  if (!geo1 && !!geo2) return true;
  if (!geo2 && !!geo1) return true;
  if (!geo1 && !geo2) return false;
  if (geo1.type !== geo2.type) return true;
  if (Array.isArray(geo1.coordinates)) {
    if (!Array.isArray(geo1.coordinates)) return true;
    if (geo1.coordinates.length !== geo2.coordinates.length) return true;
    if (geo1.coordinates[0] !== geo2.coordinates[0]) return true;
    if (geo1.coordinates[1] !== geo2.coordinates[1]) return true;
  } else if (Array.isArray(geo2.coordinates)) return true;
  return false;
};

export const outletHasChanged = (outlet1, outlet2) => {
  if (!outlet1 && !!outlet2) return true;
  if (!outlet2 && !!outlet1) return true;
  if (!outlet1 && !outlet2) return false;
  if (outlet1.id !== outlet2.id) return true;
  if (outlet1.name !== outlet2.name) return true;
  if (addressHasChanged(outlet1.address, outlet2.address)) return true;
  if (outlet1.category !== outlet2.category) return true;
  if (outlet1.description !== outlet2.description) return true;
  if (outlet1.url !== outlet2.url) return true;
  if (geometryHasChanged(outlet1.geometry, outlet2.geometry)) return true;
  return false;
};
